// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"k9-z"};